var Component = require("!../../../../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../vue-loader/lib/selector?type=script&index=0!./autocomplete-suggestions.vue"),
  /* template */
  require("!!../../../../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-00fc5cce\"}!../../../../../../vue-loader/lib/selector?type=template&index=0!./autocomplete-suggestions.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-xpc/src/element-ui/packages/autocomplete/src/autocomplete-suggestions.vue
// module id = 1961
// module chunks = 228